import { ArrowDownToLine, ArrowUpFromLine, FileClock, TriangleAlert } from 'lucide-react';
import type { RequisitionReport, StockFlowReport, TopItemsReport } from '@eombor/contracts';
import type { UseQueryResult } from '@tanstack/react-query';
import type { ApiClientError } from '../../../shared/api/client.js';
import { t } from '../../../shared/i18n/index.js';
import { MetricCard } from './MetricCard.js';

const format = (value: number): string => value.toLocaleString('ru-RU');

export interface MetricRowProps {
  flow: UseQueryResult<StockFlowReport, ApiClientError>;
  items: UseQueryResult<TopItemsReport, ApiClientError>;
  requisitions: UseQueryResult<RequisitionReport, ApiClientError>;
}

/**
 * Yuqoridagi to'rt raqam.
 *
 * Ular ALOHIDA so'rovdan kelmaydi — o'sha uchta hisobot javobidan
 * hisoblanadi. Alohida "sanoq" endpointi bo'lsa, u bir kun grafik bilan
 * zid raqam ko'rsatardi va odam qaysisiga ishonishni bilmasdi
 * (`QueueMetric` dagi bilan ayni qoida).
 *
 * So'rov yiqilsa raqam O'RNIGA chiziqcha turadi: nol ko'rsatilsa, u
 * "harakat bo'lmadi" deb o'qilardi.
 */
export const MetricRow = ({ flow, items, requisitions }: MetricRowProps) => {
  const series = flow.data?.series ?? [];
  const lowCount = items.data?.low.length ?? 0;

  return (
    <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
      <MetricCard
        icon={ArrowDownToLine}
        tone="success"
        title={t('report.metricIn')}
        hint={t('report.metricInHint')}
        loading={flow.isPending}
        value={flow.isSuccess ? format(flow.data.totals.inQty) : null}
        spark={series.map((point) => point.inQty)}
      />
      <MetricCard
        icon={ArrowUpFromLine}
        tone="info"
        title={t('report.metricOut')}
        hint={t('report.metricOutHint')}
        loading={flow.isPending}
        value={flow.isSuccess ? format(flow.data.totals.outQty) : null}
        spark={series.map((point) => point.outQty)}
      />
      <MetricCard
        icon={FileClock}
        tone="accent"
        title={t('report.metricOpen')}
        hint={t('report.metricOpenHint')}
        loading={requisitions.isPending}
        value={requisitions.isSuccess ? format(requisitions.data.openCount) : null}
      />
      <MetricCard
        icon={TriangleAlert}
        /* Tus SONGA bog'liq: nol bo'lsa ogohlantirish emas, shuning uchun
           qizil turmaydi — doim qizil turgan belgi o'qilmay qoladi. */
        tone={lowCount > 0 ? 'danger' : 'neutral'}
        title={t('report.metricLow')}
        hint={t('report.metricLowHint')}
        loading={items.isPending}
        value={items.isSuccess ? format(lowCount) : null}
      />
    </div>
  );
};
